module.exports = __webpack_public_path__ + "img/chadle_adv_03.95406305.png";